import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlFormatPipe } from './html-format.pipe';



@NgModule({
  declarations: [
    HtmlFormatPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HtmlFormatPipe
  ]
})
export class HtmlFormatPipeModule { }
